import classNames from 'classnames'

import { getQaSelector } from '../../../../utils/common'
import {
  getCalendarGridExpandedItems,
  getCalendarGridItemsInDayOrder,
  getIsCalendarGridToday,
} from '../../CalendarGrid.utils'

import { QA_NAME_CALENDAR_GRID_AGENDA_DAY } from './CalendarGridAgendaDay.constants'
import { CalendarGridAgendaDayTitle } from './CalendarGridAgendaDayTitle'
import { CalendarGridAgendaRow } from './CalendarGridAgendaRow'

import * as styles from './CalendarGridAgendaDay.module.css'

function CalendarGridAgendaDay({
  className = styles.CalendarGridAgendaDay,
  day,
  items,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const isToday = getIsCalendarGridToday({ day, today })

  return (
    <section
      {...getQaSelector({
        context: day.date,
        value: QA_NAME_CALENDAR_GRID_AGENDA_DAY,
      })}
      className={classNames(className, {
        [styles.today]: isToday,
      })}
    >
      <CalendarGridAgendaDayTitle day={day} isToday={isToday} />
      <div className={classNames(styles.rows, { [styles.rowsToday]: isToday })}>
        {getCalendarGridItemsInDayOrder(
          getCalendarGridExpandedItems(items)
        ).map(item => (
          <CalendarGridAgendaRow
            item={item}
            key={item.id}
            onClickItem={onClickItem}
            onClickSecondaryLabel={onClickSecondaryLabel}
          />
        ))}
      </div>
    </section>
  )
}

export default CalendarGridAgendaDay
